// extracted by mini-css-extract-plugin
export default {"imageWrapper":"BH-z","twoColumnImage":"CH-z"};